import React from 'react';
import classNames from 'classnames';
import { Spin } from 'antd';
import styles from './index.module.less';

export interface CardProps
  extends Omit<React.HtmlHTMLAttributes<HTMLDivElement>, 'title'> {
  loading?: boolean,
  title?: React.ReactNode;
  meta?: React.ReactNode;
  bodyClassName?: string;
}

const Card: React.FC<CardProps> = ({
  className,
  bodyClassName,
  loading,
  title,
  meta,
  children,
  ...rest
}) => (
  <div {...rest} className={classNames(styles.card, className)}>
    <Spin spinning={!!loading}>
      {title && (
      <div className={styles.head}>
        <div className={styles.title}>{title}</div>
      </div>
      )}
      {(!meta && title) && <div className={styles.border} />}
      {meta && <div className={styles.meta}>{meta}</div>}
      <div className={classNames(styles.body, bodyClassName)}>{children}</div>
    </Spin>
  </div>
);

export default Card;
